<template>
  <v-dialog :value="true" max-width="560" persistent>
    <v-card>
      <v-card-title class="headline">Apoiadores — {{ project.shortName || project.fullName }}</v-card-title>
      <v-card-text>
        <div v-if="loading" class="text-xs-center py-3"><v-progress-circular indeterminate color="primary"></v-progress-circular></div>
        <template v-else>
          <p class="caption text-gray">
            Só empresas do grupo que participam do público interno (aba Pagamentos e taxas) podem ser apoiadoras.
          </p>
          <div v-if="!options.length" class="caption">Nenhuma empresa no grupo.</div>
          <v-checkbox
            v-for="option in options"
            :key="option.companyId"
            v-model="selected"
            :value="option.companyId"
            :label="option.name + (option.participatesInCampaign ? '' : ' (não participa do público interno)')"
            :disabled="!option.participatesInCampaign && selected.indexOf(option.companyId) < 0"
            hide-details
          ></v-checkbox>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="$emit('close')">Cancelar</v-btn>
        <v-btn round color="white" class="btn-primary" :loading="saving" :disabled="loading" @click="save">Salvar apoiadores</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// Edita os apoiadores (CampaignProjectCompany) de um projeto da campanha — gravação parcial e imediata.
import CampaignEditorService from "@/scripts/services/campaignEditor.service";

const service = new CampaignEditorService();

export default {
  name: "EditorSupportersDialog",
  props: {
    campaignId: { type: [Number, String], required: true },
    project: { type: Object, required: true },
  },
  data() {
    return {
      loading: true,
      saving: false,
      options: [],
      selected: (this.project.supporters || []).map((supporter) => supporter.companyId),
    };
  },
  mounted() {
    service.getSupporterOptions(this.campaignId)
      .then((options) => {
        this.options = Object.freeze(options || []);
      })
      .catch(() => {})
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    save() {
      this.saving = true;
      service.setProjectSupporters(this.campaignId, this.project.projectId, this.selected)
        .then(() => {
          this.$store.commit("SET_SNACKBAR_SUCCESS_MESSAGE", "Apoiadores atualizados.");
          this.$emit("saved");
        })
        .catch(() => {})
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>
